import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import WarningIcon from '@mui/icons-material/Warning';
import {
    Box,
    Tooltip
} from '@mui/material';
import { useMaterialReactTable } from 'material-react-table';
import {
    AddBox as AddBoxIcon,
} from '@mui/icons-material';
import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import VerifiedIcon from '@mui/icons-material/Verified'; // ícone sugestão (pode trocar)
import { Delete } from '@material-ui/icons';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu } from '@mui/material';

import AssignmentIcon from '@mui/icons-material/Assignment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import Skeleton from '@material-ui/lab/Skeleton';
import CancelIcon from '@mui/icons-material/Cancel';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import EditNoteIcon from '@mui/icons-material/EditNote';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import TaskIcon from '@mui/icons-material/Task';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import MenuIcon from '@mui/icons-material/Menu';
import {

    Divider
} from "@mui/material";
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import moment from 'moment'; // Importe a biblioteca Moment.js
import { Drawer, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PaidIcon from '@mui/icons-material/Paid';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import api from '../../../../../services/api';
import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import LinkIcon from '@mui/icons-material/Link';
import ReactApexChart from 'react-apexcharts';

import Rodape from '../../../../../components/Rodape';
import {
    MaterialReactTable,

} from 'material-react-table';
import { Button, MenuItem, Select, InputLabel } from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { styled } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CircularProgress, DialogActions, DialogContentText } from '@mui/material';

import AppBar from '@mui/material/AppBar';
import TextField from '@material-ui/core/TextField';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Snackbar, Alert, Backdrop } from '@mui/material';
import { Card, CardContent, Typography, Collapse } from '@mui/material';
import { ArrowUpward, ArrowDownward, MoreVert, AttachMoney, ShoppingBasket } from '@mui/icons-material';

import { useMediaQuery, useTheme } from '@mui/material';




const drawerWidth = 240;



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    table: {
        minWidth: 650,
    },
}));

const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));


const styles = {
    card: {
        borderRadius: '12px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '200px',
    },
    purpleCard: {
        backgroundColor: '#6a1b9a',
        color: '#fff',
    },
    blueCard: {
        backgroundColor: '#0288d1',
        color: '#fff',
    },
    iconBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    iconBackground: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        padding: '8px',
    },
    graphBox: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        height: '40px',
        marginTop: '8px',
    },

};


export default function DashboadGeral({ darkMode }) {


    const totalDespesasPagoMesAtual = 8000;
    const totalDespesasAPagarMesAtual = 3000;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // considera mobile se for menor ou igual a 'sm'


    const [loading, setLoading] = useState(true);


    const hoje = new Date();
    const [mesAtual, setMesAtual] = useState(hoje.getMonth() + 1); // getMonth() retorna 0-11, então +1
    const [anoAtual, setAnoAtual] = useState(hoje.getFullYear());

    const [dados, setDados] = useState(null);


    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });


    const [chartWidth, setChartWidth] = useState(window.innerWidth * 0.9);

    useEffect(() => {
        const handleResize = () => setChartWidth(window.innerWidth * 0.9);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const dadosGrafico = {
        options: {
            chart: {
                id: 'area-chart'
            },
            xaxis: {
                categories: null
            }
        },
        series: [
            {
                name: 'Valor Total',
                data: null
            }
        ]
    };


    async function listar() {
        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const response = await api.get(
                `v1/protected/ordensdecompras/dashboard?mes=${mesAtual}&ano=${anoAtual}`,
                { headers }
            );

            const respData = response.data;
            setDados(respData); // salva os dados brutos

            // ====== Processando dados para gráfico ======
            const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
            const categorias = respData.evolucao_mensal_json.map(m => meses[m.mes - 1]);
            const valores = respData.evolucao_mensal_json.map(m => parseFloat(m.valor_total.toFixed(2)));

            const grafico = {
                options: {
                    chart: { id: 'area-chart' },
                    xaxis: { categorias }
                },
                series: [{ name: 'Valor Total', data: valores }]
            };

            setDados(prev => ({ ...prev, grafico })); // adiciona os dados do gráfico no state

            setLoading(false);

        } catch (err) {
            console.log("Erro ao listar objetos: " + err)
            setLoading(false);
        }
    }
    useEffect(() => {

        listar();
    }, []);

    useEffect(() => {
        const mesInt = parseInt(mesAtual, 10);
        const anoInt = parseInt(anoAtual, 10);

        const mesValido = !isNaN(mesInt) && mesInt >= 0 && mesInt <= 12;
        const anoValido = !isNaN(anoInt) && anoInt >= 0 && anoInt <= 3000;

        if (mesValido && anoValido) {
            listar();
        }
    }, [mesAtual, anoAtual]);



    return (
        <div style={{
            backgroundColor: darkMode ? '#121212' : 'transparent',
            color: darkMode ? '#fff' : 'inherit',
            minHeight: '100%',
        }}>
            {
                !loading && dados &&
                (
                    <Grid item xs={12} container spacing={2} style={{ width: '100%', margin: 10 }} direction={'row'} >

                        {isMobile && (
                            <Grid item xs={12} style={{ padding: 10 }}

                                direction={'row'}
                                justifyContent={'center'}
                                alignItens={'center'}
                            >
                                <Card
                                    style={{
                                        ...styles.card,
                                        ...styles.blueCard,
                                        height: '100px',
                                        padding: 5,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        textAlign: 'center',
                                        boxShadow: darkMode ? '0px 4px 8px rgba(0,0,0,0.5)' : '0px 4px 8px rgba(0,0,0,0.2)',
                                        backgroundColor: darkMode ? '#1e1e1e' : '#0288d1',
                                        color: '#fff',
                                    }}
                                >
                                    <CardContent style={{ padding: 8 }}>
                                        {/* MÊS */}
                                        <TextField
                                            variant="standard"
                                            value={mesAtual}
                                            onChange={(e) => setMesAtual(e.target.value)}
                                            inputProps={{
                                                style: {
                                                    textAlign: 'center',
                                                    fontSize: '2rem',
                                                    fontWeight: 'bold',
                                                    color: '#fff',
                                                    width: '70px',
                                                },
                                                maxLength: 2,
                                            }}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />

                                        {/* ANO */}
                                        <TextField
                                            variant="standard"
                                            value={anoAtual}
                                            onChange={(e) => setAnoAtual(e.target.value)}
                                            inputProps={{
                                                style: {
                                                    textAlign: 'center',
                                                    fontSize: '1rem',
                                                    color: '#e0e0e0',
                                                    letterSpacing: '1px',
                                                    width: '80px',
                                                },
                                                maxLength: 4,
                                            }}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                        )}

                        <Grid
                            item xs={12} sm={12} md={12} lg={9} xl={9}
                            container spacing={2} style={{ width: '100%' }} direction={'row'} >

                            <Grid
                                item xs={12} sm={12} md={12} lg={6} xl={6}
                            >
                                <Card style={{ ...styles.card, ...styles.blueCard, backgroundColor: darkMode ? '#1e1e1e' : '#0288d1', color: darkMode ? '#fff' : '#fff' }}>
                                    <CardContent>
                                        <Box style={styles.iconBox}>
                                            <Box style={{ ...styles.iconBackground, backgroundColor: darkMode ? 'rgba(255,255,255,0.15)' : styles.iconBackground.backgroundColor }}>
                                                <ShoppingBasket style={{ color: '#fff' }} />
                                            </Box>
                                        </Box>



                                        <Typography variant="h4" style={{ color: '#fff' }}>{currencyFormatter.format(dados.valorTotal)}</Typography>
                                        <Box display="flex" alignItems="center">
                                            <ArrowUpward style={{ fontSize: 14, marginRight: 4, color: '#fff' }} />
                                            <Typography variant="body2" style={{ color: darkMode ? '#e0e0e0' : '#fff' }}>{"em compras efetuadas no período selecionado"}</Typography>
                                        </Box>


                                        <Box style={{ ...styles.graphBox, backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : styles.graphBox.backgroundColor }}></Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid
                                item xs={12} sm={12} md={12} lg={6} xl={6}
                            >
                                <Card style={{ ...styles.card, ...styles.purpleCard, position: 'relative', overflow: 'hidden', backgroundColor: darkMode ? '#2d2d2d' : '#6a1b9a', color: '#fff' }}>
                                    <CardContent style={{ zIndex: 3 }}>
                                        <Grid container>
                                            {/* Total de Ordens de Compra */}
                                            <Grid item xs={6} style={{ textAlign: 'center', padding: '16px', borderRight: darkMode ? '2px solid #555' : '2px solid white' }}>
                                                <Typography variant="h5" style={{ color: '#fff' }}>{dados?.totalOrdensCompra ?? 0}</Typography>
                                                <Typography variant="body2" style={{ color: darkMode ? '#e0e0e0' : '#fff' }}>Total de Ordens de Compra</Typography>
                                            </Grid>

                                            {/* Valor Médio por OC */}
                                            <Grid item xs={6} style={{ textAlign: 'center', padding: '16px' }}>
                                                <Typography variant="h5" style={{ color: '#fff' }}>{currencyFormatter.format(dados?.valorMedioPorOC ?? 0)}</Typography>
                                                <Typography variant="body2" style={{ color: darkMode ? '#e0e0e0' : '#fff' }}>Valor médio por OC</Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>

                                    {/* Círculos decorativos */}
                                    <Box style={{
                                        position: 'absolute',
                                        top: -200,
                                        right: -200,
                                        width: 350,
                                        height: 350,
                                        backgroundColor: '#9673c3',
                                        borderRadius: '50%',
                                        opacity: 0.5,
                                        zIndex: 1,
                                    }}></Box>

                                    <Box style={{
                                        position: 'absolute',
                                        top: -150,
                                        right: -150,
                                        width: 400,
                                        height: 250,
                                        backgroundColor: '#3a1e56',
                                        borderRadius: '50%',
                                        opacity: 0.5,
                                        zIndex: 0,
                                    }}></Box>
                                </Card>
                            </Grid>




                            {!loading && dados?.grafico && (
                                <Grid item xs={12} container>
                                    <ReactApexChart
                                        options={{
                                            ...dados.grafico.options,
                                            theme: { mode: darkMode ? 'dark' : 'light' },
                                            chart: { ...(dados.grafico.options?.chart || {}), background: darkMode ? '#1e1e1e' : 'transparent' },
                                            grid: { borderColor: darkMode ? '#444' : '#e0e0e0' },
                                            xaxis: { ...(dados.grafico.options?.xaxis || {}), labels: { style: { colors: darkMode ? '#e0e0e0' : undefined } } },
                                            yaxis: { labels: { style: { colors: darkMode ? '#e0e0e0' : undefined } } },
                                        }}
                                        series={dados.grafico.series}
                                        type="area"
                                        height={isMobile ? 400 : 400}
                                        width={isMobile ? chartWidth : 800}
                                    />
                                </Grid>
                            )}
                        </Grid>


                        <Grid
                            item xs={12} sm={12} md={12} lg={3} xl={3}
                            container style={{ width: '100%' }} spacing={1} direction={'row'} justifyContent={'flex-start'} alignItens={'flex-start'} >
                            {!isMobile && (
                                <Grid item xs={12}>
                                    <Card
                                        style={{
                                            ...styles.card,
                                            ...styles.blueCard,
                                            height: '100px',
                                            padding: 5,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            flexDirection: 'column',
                                            textAlign: 'center',
                                            boxShadow: darkMode ? '0px 4px 8px rgba(0,0,0,0.5)' : '0px 4px 8px rgba(0,0,0,0.2)',
                                            backgroundColor: darkMode ? '#1e1e1e' : '#0288d1',
                                            color: '#fff',
                                        }}
                                    >
                                        <CardContent style={{ padding: 8 }}>
                                            {/* MÊS */}
                                            <TextField
                                                variant="standard"
                                                value={mesAtual}
                                                onChange={(e) => setMesAtual(e.target.value)}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'center',
                                                        fontSize: '2rem',
                                                        fontWeight: 'bold',
                                                        color: '#fff',
                                                        width: '70px',
                                                    },
                                                    maxLength: 2,
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />

                                            {/* ANO */}
                                            <TextField
                                                variant="standard"
                                                value={anoAtual}
                                                onChange={(e) => setAnoAtual(e.target.value)}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'center',
                                                        fontSize: '1rem',
                                                        color: '#e0e0e0',
                                                        letterSpacing: '1px',
                                                        width: '80px',
                                                    },
                                                    maxLength: 4,
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )}

                            <Grid
                                item xs={12} sm={12} md={12} lg={12} xl={12}
                            >

                                {/* Cabeçalho */}
                                <div
                                    style={{
                                        fontWeight: 'bold',
                                        padding: '6px 0',
                                        fontSize: '14px',
                                        borderBottom: darkMode ? '2px solid #444' : '2px solid white',
                                        textTransform: 'uppercase',
                                        color: darkMode ? '#fff' : 'inherit',
                                    }}
                                >
                                    Ranking de Usuários
                                </div>

                                {/* Cabeçalho da tabela */}
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        padding: '6px 5px',
                                        backgroundColor: darkMode ? '#333' : '#1976d2',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        fontSize: '13px',
                                        borderTopLeftRadius: '6px',
                                        borderTopRightRadius: '6px',
                                    }}
                                >
                                    <span style={{ flex: 2, textAlign: 'left' }}>Nome</span>
                                    <span style={{ flex: 1.5, textAlign: 'right' }}>Autorizador</span>
                                    <span style={{ flex: 1.5, textAlign: 'right' }}>Solicitante</span>
                                </div>

                                {/* Corpo com scroll vertical */}
                                <div
                                    style={{
                                        flex: 1,
                                        overflowY: 'auto',
                                        backgroundColor: darkMode ? '#1e1e1e' : '#fafafa',
                                        borderBottomLeftRadius: '6px',
                                        borderBottomRightRadius: '6px',
                                    }}
                                >
                                    {dados?.usuarios_json?.length > 0 ? (
                                        dados.usuarios_json.map((ranking, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    padding: '6px 5px',
                                                    backgroundColor: index % 2 === 0 ? (darkMode ? '#2d2d2d' : '#ffffff') : (darkMode ? '#1e1e1e' : '#f4f4f4'),
                                                    color: darkMode ? '#eee' : '#222',
                                                    fontSize: '13px',
                                                    alignItems: 'center',
                                                    transition: 'background-color 0.2s',
                                                    cursor: 'default',
                                                }}
                                                onMouseEnter={(e) =>
                                                    (e.currentTarget.style.backgroundColor = darkMode ? '#404040' : '#e6f7ff')
                                                }
                                                onMouseLeave={(e) =>
                                                (e.currentTarget.style.backgroundColor =
                                                    index % 2 === 0 ? (darkMode ? '#2d2d2d' : '#ffffff') : (darkMode ? '#1e1e1e' : '#f4f4f4'))
                                                }
                                            >

                                                <span style={{ flex: 2, textAlign: 'left' }}>{ranking.nome}</span>
                                                <span style={{ flex: 1.5, textAlign: 'right' }}>
                                                    {Number(ranking.valorcomoautorizador).toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </span>
                                                <span style={{ flex: 1.5, textAlign: 'right' }}>
                                                    {Number(ranking.valorcomosolicitante).toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </span>
                                            </div>
                                        ))
                                    ) : (
                                        <div
                                            style={{
                                                textAlign: 'center',
                                                padding: '10px',
                                                color: darkMode ? '#aaa' : '#666',
                                                fontSize: '13px',
                                            }}
                                        >
                                            Nenhum usuário encontrado
                                        </div>
                                    )}
                                </div>
                            </Grid>


                            <Grid item xs={12}>

                            </Grid>


                            <Grid item xs={12} >
                            </Grid>

                        </Grid>

                        <Grid
                            item xs={12} sm={12} md={12} lg={6} xl={6}
                        >
                            {/* Cabeçalho */}
                            <div
                                style={{
                                    fontWeight: 'bold',
                                    padding: '6px 0',
                                    fontSize: '14px',
                                    borderBottom: darkMode ? '2px solid #444' : '2px solid white',
                                    textTransform: 'uppercase',
                                    color: darkMode ? '#fff' : 'inherit',
                                }}
                            >
                                Ranking de Fornecedores
                            </div>

                            {/* Cabeçalho da "tabela" */}
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '6px 5px',
                                    backgroundColor: darkMode ? '#333' : '#1976d2',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: '13px',
                                    borderTopLeftRadius: '6px',
                                    borderTopRightRadius: '6px',
                                }}
                            >
                                <span style={{ flex: 2, textAlign: 'left' }}>Fornecedor</span>
                                <span style={{ flex: 1.5, textAlign: 'right' }}>Total</span>
                                <span style={{ flex: 1, textAlign: 'center' }}>Nº O.Cs</span>
                                <span style={{ flex: 2, textAlign: 'left' }}>Item Mais Comprado</span>
                            </div>

                            {/* Corpo com scroll vertical */}
                            <div
                                style={{
                                    flex: 1,
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    backgroundColor: darkMode ? '#1e1e1e' : '#fafafa',
                                    borderBottomLeftRadius: '6px',
                                    borderBottomRightRadius: '6px',
                                }}
                            >
                                {dados?.fornecedores_json && dados.fornecedores_json.length > 0 ? (
                                    [...dados.fornecedores_json]
                                        .sort((a, b) => b.valor_total_pre_cotacao - a.valor_total_pre_cotacao)
                                        .map((f, index) => (
                                            <div
                                                key={`${f.id_fornecedor}-${index}`}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    padding: '6px 5px',
                                                    backgroundColor: index % 2 === 0 ? (darkMode ? '#2d2d2d' : '#ffffff') : (darkMode ? '#1e1e1e' : '#f4f4f4'),
                                                    color: darkMode ? '#eee' : '#222',
                                                    fontSize: '13px',
                                                    alignItems: 'center',
                                                    transition: 'background-color 0.2s',
                                                    cursor: 'pointer',
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = darkMode ? '#404040' : '#e6f7ff')}
                                                onMouseLeave={(e) =>
                                                    (e.currentTarget.style.backgroundColor = index % 2 === 0 ? (darkMode ? '#2d2d2d' : '#ffffff') : (darkMode ? '#1e1e1e' : '#f4f4f4'))
                                                }
                                            >
                                                <span style={{ flex: 2, textAlign: 'left' }}>{f.fornecedor}</span>
                                                <span style={{ flex: 1.5, textAlign: 'right' }}>
                                                    {f.valor_total_pre_cotacao.toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </span>
                                                <span style={{ flex: 1, textAlign: 'center' }}>{f.numero_pre_cotacoes}</span>
                                                <span style={{ flex: 2, textAlign: 'left' }}>{f.item_mais_comprado}</span>
                                            </div>
                                        ))
                                ) : (
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            padding: '10px',
                                            color: darkMode ? '#aaa' : '#666',
                                            fontSize: '13px',
                                        }}
                                    >
                                        Nenhum fornecedor encontrado
                                    </div>
                                )}
                            </div>
                        </Grid>

                        <Grid
                            item xs={12} sm={12} md={12} lg={6} xl={6}
                        >
                            {/* Cabeçalho */}
                            <div
                                style={{
                                    fontWeight: 'bold',
                                    padding: '6px 0',
                                    fontSize: '14px',
                                    borderBottom: darkMode ? '2px solid #444' : '2px solid white',
                                    textTransform: 'uppercase',
                                    color: darkMode ? '#fff' : 'inherit',
                                }}
                            >
                                Top 5 Insumos Mais Comprados
                            </div>

                            {/* Cabeçalho da tabela */}
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '6px 5px',
                                    backgroundColor: darkMode ? '#333' : '#1976d2',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: '13px',
                                    borderTopLeftRadius: '6px',
                                    borderTopRightRadius: '6px',
                                }}
                            >
                                <span style={{ flex: 3, textAlign: 'left' }}>Insumo</span>
                                <span style={{ flex: 1, textAlign: 'right' }}>Quantidade Total</span>
                            </div>

                            {/* Corpo com scroll vertical */}
                            <div
                                style={{
                                    flex: 1,
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    backgroundColor: darkMode ? '#1e1e1e' : '#fafafa',
                                    borderBottomLeftRadius: '6px',
                                    borderBottomRightRadius: '6px',
                                }}
                            >
                                {dados?.top5_insumos_mais_comprados && dados.top5_insumos_mais_comprados.length > 0 ? (
                                    [...dados.top5_insumos_mais_comprados]
                                        .sort((a, b) => b.quantidade_total - a.quantidade_total) // garante ordenação decrescente
                                        .map((item, index) => (
                                            <div
                                                key={`${item.insumo}-${index}`}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    padding: '6px 5px',
                                                    backgroundColor: index % 2 === 0 ? (darkMode ? '#2d2d2d' : '#ffffff') : (darkMode ? '#1e1e1e' : '#f4f4f4'),
                                                    color: darkMode ? '#eee' : '#222',
                                                    fontSize: '13px',
                                                    alignItems: 'center',
                                                    transition: 'background-color 0.2s',
                                                    cursor: 'default',
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = darkMode ? '#404040' : '#e6f7ff')}
                                                onMouseLeave={(e) =>
                                                    (e.currentTarget.style.backgroundColor = index % 2 === 0 ? (darkMode ? '#2d2d2d' : '#ffffff') : (darkMode ? '#1e1e1e' : '#f4f4f4'))
                                                }
                                            >
                                                <span style={{ flex: 3, textAlign: 'left' }}>{item.insumo}</span>
                                                <span style={{ flex: 1, textAlign: 'right' }}>{item.quantidade_total}</span>
                                            </div>
                                        ))
                                ) : (
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            padding: '10px',
                                            color: darkMode ? '#aaa' : '#666',
                                            fontSize: '13px',
                                        }}
                                    >
                                        Nenhum insumo encontrado
                                    </div>
                                )}
                            </div>
                        </Grid>


                    </Grid>
                )
            }
        </div>
    );
}
